import { SxProps } from "@mui/material";
import { TextInput } from "../OtherModal/style";
import type { ThemeV2 } from "../../../util/types";

export const autocompleteWrapper: SxProps = {
  alignItems: "center",
  display: "flex",
  gap: { xs: 1, sm: 1.5 },
  width: "100%",
};

export const autocompleteStyle: SxProps = {
  flex: 1,
  minWidth: 0,
};

export const selectedSingleWrapper: SxProps = {
  alignItems: "center",
  display: "flex",
  minWidth: 0,
};

export const selectedMultipleWrapper: SxProps = {
  alignItems: "center",
  display: "flex",
  maxWidth: "100%",
  minWidth: 0,
};

export const selectedChipStyle: SxProps = {
  maxWidth: "100%",
};

export const selectedSingleImageStyle: SxProps = {
  height: { xs: "28px", sm: "32px" },
  objectFit: "contain",
  width: { xs: "28px", sm: "32px" },
};

export const selectedMultipleImageStyle: SxProps = {
  height: { xs: "24px", sm: "28px" },
  objectFit: "contain",
  width: { xs: "24px", sm: "28px" },
};

export const optionImageStyle: SxProps = {
  height: { xs: "36px", sm: "44px" },
  objectFit: "contain",
  width: { xs: "36px", sm: "44px" },
};

export const autocompleteInputStyle = (
  theme: ThemeV2,
  primaryColor: string,
  inputBgColor?: string,
): SxProps => ({
  ...TextInput(theme, primaryColor),
  "& .MuiInputLabel-root": {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px",
  },
  "& .MuiOutlinedInput-notchedOutline legend": {
    maxWidth: 0,
  },
  backgroundColor: inputBgColor,
});
